var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"flex items-center text-gray-600 cursor-pointer",class:_vm.extraClassName,on:{"click":function($event){$event.preventDefault();return _vm.$emit('clicked')}}},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"block h-8 w-[1px]"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }